/* eslint-disable jsx-a11y/media-has-caption */
import * as React from "react";
import { ArtisanContent } from "./ArtisanContent";

export function Artisan() {
  const videoRef = React.useRef(null);
  const [inView, setInView] = React.useState(false);
  const [srcMp4, setSrcMp4] = React.useState(""); // динамик src

  // 1) viewport-д ормогц идэвхжүүлнэ
  React.useEffect(() => {
    const el = videoRef.current;
    if (!el) return;
    const io = new IntersectionObserver(
      (entries) => {
        if (entries[0]?.isIntersecting) {
          setInView(true);
          io.disconnect();
        }
      },
      { rootMargin: "200px" }
    );
    io.observe(el);
    return () => io.disconnect();
  }, []);

  // 2) чанар сонгоод src онооно (ганц файлтай бол шууд тэрийгээ тавь)
  React.useEffect(() => {
    if (!inView) return;
    // Хэрэв ганц л файл байвал:
    setSrcMp4("/media/artisan.mp4");
    // Хэрэв 480/720 хоёр байвал доор сүлжээ шалгаад сонго:
    // const c = navigator.connection;
    // const slow = ["slow-2g","2g"].includes(c?.effectiveType || "") || c?.saveData;
    // setSrcMp4(slow ? "/media/artisan_480.mp4" : "/media/artisan_720.mp4");
  }, [inView]);

  // 3) src оноогдмогц video.load() → play()
  React.useEffect(() => {
    const v = videoRef.current;
    if (!v || !srcMp4) return;

    // muted / playsInline нь autoplay-ийн шаардлага тул ЭХЛЭЭД attribute-ууд байгаа эсэхээ шалга
    v.muted = true; // safety
    v.setAttribute("playsInline", "true");

    // Шинэ эх сурвалжийг уншуулж тоглуулна
    v.load();
    const tryPlay = async () => {
      try {
        await v.play();
      } catch (err) {
        // Заримдаа autoplay блоклогдож болно — controls асаах эсвэл товчоор play хийх fallback бодоорой
        console.warn("Autoplay blocked, will wait for user gesture", err);
      }
    };
    // metadata ачаалсны дараа play хийх нь найдвартай
    const onLoadedMeta = () => tryPlay();
    v.addEventListener("loadedmetadata", onLoadedMeta);

    // Алдаа гарвал консолд харагдуулж оношлоход тус болно
    const onError = (e) => console.error("Video error:", e);
    v.addEventListener("error", onError);

    return () => {
      v.removeEventListener("loadedmetadata", onLoadedMeta);
      v.removeEventListener("error", onError);
    };
  }, [srcMp4]);

  return (
    <div className="flex flex-col text-xl font-light text-white">
      <div className="relative w-full aspect-video max-md:h-[700px] md:aspect-[16/9]">
        <video
          ref={videoRef}
          className="absolute inset-0 w-full h-full object-cover z-0"
          preload="none"
          poster="/media/artisan_poster.jpg"
          autoPlay
          loop
          muted
          playsInline
        >
          {/* src-аа <source> дээр онооно */}
          {srcMp4 && <source src={srcMp4} type="video/mp4" />}
          Таны браузер видео тоглуулахгүй байна.
        </video>

        <div className="relative z-20 flex justify-center items-center w-full h-full px-20 max-md:px-5">
          <ArtisanContent />
        </div>
        <div className="absolute inset-0 bg-black/40 z-10" />
      </div>

      <div className="md:hidden px-5 mt-5">
        <ArtisanContent mobileOnly />
      </div>
    </div>
  );
}
